"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AGORA_TOKEN_ENDPOINT = exports.AGORA_APP_ID = void 0;
exports.AGORA_APP_ID = 'b1d2d763c7af4fd9925649c7d2cb4bc0';
exports.AGORA_TOKEN_ENDPOINT = 'https://meci.teymensel.com/api/v1/agora/token';
